(function () {
    'use strict';
    angular
        .module('ib-new-seat-map-module')
        .directive('ibCollapseSibling', ibCollapseSibling);

    ibCollapseSibling.$inject = ['$timeout', '$window'];

    function ibCollapseSibling ($timeout) {
        return {
            restrict: 'AE',
            link: link
        };
        function link (scope, elem) {
            // Launch event resize when clicks in a collapse card
            $timeout(() => {
                angular.element('[data-attr="sibling-collapse"]').bind('click', (e) => {

                    if( (elem[0].className === 'in collapse')) {
                        scope.collapse.isCollapsed = !scope.collapse.isCollapsed;
                    }
                });
            });
        }
    }
})();

